export default __webpack_public_path__ + "static/media/background-net.ca13374e.jpg";